
<div id="mainLoader" class="mainLoader" *ngIf="showLoader">
    <div class="loader-parent">
      <div class="line" [ngClass]="{'k12': productName == 'k12'}"></div>
      <div class="line" [ngClass]="{'k12': productName == 'k12'}"></div>
      <div class="line" [ngClass]="{'k12': productName == 'k12'}"></div>
      <div class="line k12" *ngIf="productName == 'k12'"></div>
    </div>
  </div>